export type GeneratePath = (path: string, params: { [key: string]: string }) => string

export interface StateParams {
  [key: string]: number | string
}

export const generatePath: GeneratePath = (path, params) => {
  try {
    const paramKeys = Object.keys(params)
    let targetPath = path

    paramKeys.forEach((key) => {
      targetPath = targetPath.replace(/:\w+/, params[key])
    })

    return targetPath
  } catch (error) {
    return path
  }
}
